import {
  memo,
  useCallback,
  type FC
} from 'react';
import {
  Stack,
  Skeleton,
  Typography
} from '@mui/joy';
import {
  ChosenCoinPackageCard,
  type CoinPackage,
} from '@entities/coins';

const LimitedCoinPackageListSkeleton: FC = () => (
  <Stack width='100%' gap={2}>
    {[...Array(3)].map((_, index) => (
      <Skeleton
        variant='rectangular'
        height='113px'
        key={index}
        sx={{
          height: index === 1 ? '139px' : '113px',
          borderRadius: 8
        }}
      />
    ))}
  </Stack>
);

export type LimitedCoinPackageListProps = {
  loading?: boolean;
  items: Maybe<Array<CoinPackage>>;
  onPurchaseSelection?(coinPackage: CoinPackage): void;
};

export const LimitedCoinPackageList: FC<LimitedCoinPackageListProps> = memo(({
  loading,
  items,
  onPurchaseSelection
}) => {
  const handlePurchase = useCallback(
    (coinPackage: CoinPackage) => !loading && onPurchaseSelection?.(coinPackage),
    [loading, items, onPurchaseSelection]
  );
  return loading ? (
    <LimitedCoinPackageListSkeleton />
  ) : (
    <Stack
      height='100%'
      width='100%'
      gap={3}>
      <Typography
        sx={{
          fontSize: 22,
          fontWeight: 600,
          fontStyle: 'normal',
          lineHeight: '20px',
          textAlign: 'center',
        }}>
        Limited time offer
      </Typography>
      <Stack gap={2}>
        {items?.map(({ id, variant, ...props }) => (
          <ChosenCoinPackageCard
            key={id}
            darkMode
            isClaimed
            data={{ id, variant, ...props }}
            onPurchase={handlePurchase}
          />
        ))}
      </Stack>
    </Stack>
  );
});